import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-overload-page',
  templateUrl: './request-overload-page.component.html',
  styleUrls: ['./request-overload-page.component.css']
})
export class RequestOverloadComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy(){
  }

}
